"use client";
import { CircleCheck, CircleX } from "lucide-react";

interface TipsSectionProps {
  dos?: string;
  donts?: string;
}

export default function TipsSection({ dos, donts }: TipsSectionProps) {
  if (!dos && !donts) return null;

  return (
    <section className="py-24 bg-[#F9F7F4]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl mb-12 text-center text-[#1A1A1A]">
          Visitor Tips
        </h2>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Do's */}
          {dos && (
            <div>
              <div className="flex items-center gap-3 mb-6">
                <CircleCheck className="h-8 w-8 text-green-600" />
                <h3 className="text-2xl text-[#1A1A1A]">Do's</h3>
              </div>
              <div
                className="text-gray-700 leading-relaxed Dos-list"
                dangerouslySetInnerHTML={{
                  __html: dos,
                }}
              />
            </div>
          )}

          {/* Don't */}
          {donts && (
            <div>
              <div className="flex items-center gap-3 mb-6">
                <CircleX className="h-8 w-8 text-red-600" />
                <h3 className="text-2xl text-[#1A1A1A]">Don't</h3>
              </div>
              <div
                className="text-gray-700 leading-relaxed Donts-list"
                dangerouslySetInnerHTML={{
                  __html: donts,
                }}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
